import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Heading,
  Divider,
  Box,
} from '@chakra-ui/react';

const LegalModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent borderRadius="none" bg="card.bg" color="hero.text" border="1px solid" borderColor="card.border">
        <ModalHeader borderBottom="1px solid" borderColor="card.border" py={4}>
          <Heading size="sm" fontWeight="900" letterSpacing="widest" textTransform="uppercase">
            LEGAL INFORMATION
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody py={6}>
          <VStack align="stretch" spacing={8}>
            {/* TERMS OF USE SECTION */}
            <Box>
              <Heading size="xs" mb={4} color="brand.red" textTransform="uppercase" letterSpacing="wider">
                Terms of Use
              </Heading>
              <VStack align="stretch" spacing={3}>
                <Text fontSize="xs" fontWeight="bold">Last Updated: March 25, 2026</Text>
                <Text fontSize="xs">
                  By using the Ballometer application, you agree to the following terms and conditions.
                </Text>
                <Text fontSize="xs" fontWeight="900">1. INTELLECTUAL PROPERTY RIGHTS</Text>
                <Text fontSize="xs">
                  The Application, including its user interface (UI), user experience (UX) design, specialized "Broadcast" aesthetics, algorithmic logic, and all creative assets, are the exclusive intellectual property of <Box as="span" fontWeight="bold">Doug Beatty</Box>.
                </Text>
                <Text fontSize="xs" fontWeight="900">2. USAGE AND ATTRIBUTION</Text>
                <Text fontSize="xs">
                  Prohibited Use: You may not copy, redistribute, or reproduce the design, styling, or source code of this Application for use in other projects without express written consent.
                </Text>
                <Text fontSize="xs">
                  Mandatory Attribution: Any public display, screenshot, or derivative work referencing the Application's design must provide clear and visible attribution to <Box as="span" fontWeight="bold">Doug Beatty</Box> and <Box as="span" fontWeight="bold">Ballometer</Box>.
                </Text>
                <Text fontSize="xs" fontWeight="900">3. DISCLAIMER OF WARRANTIES</Text>
                <Text fontSize="xs" fontStyle="italic">
                  THE APPLICATION IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. THE AUTHOR SHALL NOT BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY.
                </Text>
              </VStack>
            </Box>

            <Divider borderColor="card.border" />

            {/* PRIVACY POLICY SECTION */}
            <Box>
              <Heading size="xs" mb={4} color="brand.red" textTransform="uppercase" letterSpacing="wider">
                Privacy Policy
              </Heading>
              <VStack align="stretch" spacing={3}>
                <Text fontSize="xs" fontWeight="bold">Last Updated: March 25, 2026</Text>
                <Text fontSize="xs" fontWeight="900">1. DATA COLLECTION</Text>
                <Text fontSize="xs">
                  Ballometer is designed as a local-first application. We do not collect, store, or transmit any personal identification information to external servers. Any data retrieved from the MLB Stats API is used solely for the purpose of real-time display and data calculations.
                </Text>
                <Text fontSize="xs" fontWeight="900">2. LOCAL STORAGE</Text>
                <Text fontSize="xs">
                  The Application may use your browser's local storage to save your settings (theme preferences, team selections) locally on your device.
                </Text>
                <Text fontSize="xs" fontWeight="900">3. THIRD-PARTY SERVICES</Text>
                <Text fontSize="xs">
                  Data is provided by the MLB Stats API and is subject to their own data usage policies.
                </Text>
              </VStack>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter borderTop="1px solid" borderColor="card.border">
          <Button variant="solid" onClick={onClose} size="sm">
            DISMISS
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LegalModal;
